module.exports = __webpack_public_path__ + "img/audio-pause-blue.5becbc05.png";